// Featured collections show four dedicated cards below 700px. Only the desktop
// list's 700–767px swipe layout exposes slides beyond the two hover photos.
const swipeLayout = matchMedia('(min-width: 700px) and (max-width: 767px)');
function queryTemplates(root, selector) {
  return root.matches?.(selector) ? [root] : root.querySelectorAll(selector);
}

function syncSwipeMedia(root = document) {
  const templates = queryTemplates(root, 'template[data-df-swipe-media]');
  templates.forEach(template => {
    if (swipeLayout.matches && template.content.childElementCount) {
      template.after(template.content);
      template.dataset.mounted = 'true';
    } else if (!swipeLayout.matches && template.dataset.mounted === 'true') {
      const media = template.nextElementSibling;
      media.querySelectorAll('video').forEach(video => video.pause());
      template.content.append(media);
      delete template.dataset.mounted;
    }
  });
}
// Hydrate each recommendation presentation only on its first activation. Keep
// already visited media mounted: moving a native player into an inert template
// resets its video but preserves the player's state. Existing card-video handlers
// pause the presentation when CSS hides it and resume visible touch/hover media.
const desktopLayout = matchMedia('(min-width: 700px)');
function syncCardLayouts(root = document) {
  const templates = queryTemplates(root, 'template[data-df-card-layout]');
  templates.forEach(template => {
    if ((template.dataset.dfCardLayout === 'desktop') === desktopLayout.matches) {
      template.replaceWith(template.content);
    }
  });
}
syncCardLayouts();
desktopLayout.addEventListener('change', () => syncCardLayouts());
syncSwipeMedia();
swipeLayout.addEventListener('change', () => syncSwipeMedia());
new MutationObserver(records => {
  records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType === 1) {
      syncCardLayouts(node);
      syncSwipeMedia(node);
    }
  }));
}).observe(document.documentElement, { childList: true, subtree: true });
